// extracted by mini-css-extract-plugin
var _1 = "ra-promo-card";
var _2 = "ra-promo-card-icon";
var _3 = "ra-promo-card-link";
var _4 = "ra-promo-card-text";
var _5 = "ra-promo-card-title";
export { _1 as "promotionalCardCls", _2 as "promotionalCardIconCls", _3 as "promotionalCardLinkCls", _4 as "promotionalCardTextCls", _5 as "promotionalCardTitleCls" }
